angular.module("app").controller("MobileConfigurationsPageController", [
    '$scope',
    'preloadedConfigs',
    'preloadedConfigTypes',
    'preloadedVersions',
    'mobileConfigsService',
    'errorHandler',
    'logger',
    'deepCompare',
    '$window',
    '$uibModal',
    'settingsService',
    '$filter',
    '$timeout',
    'userStorage',
    'preloadedSkinsList',
    '$controller',
    '$stateParams',
    function ($scope,
              preloadedConfigs,
              preloadedConfigTypes,
              preloadedVersions,
              mobileConfigsService,
              errorHandler,
              logger,
              deepCompare,
              $window,
              $modal,
              settingsService,
              $filter,
              $timeout,
              userStorage,
              preloadedSkinsList,
              $controller,
              $stateParams ) {

        var dependency = {
                $scope: $scope,
                preloadedConfigs: preloadedConfigs,
                preloadedConfigTypes: preloadedConfigTypes,
                preloadedVersions: preloadedVersions,
                mobileConfigsService: mobileConfigsService,
                errorHandler: errorHandler,
                logger: logger,
                deepCompare: deepCompare,
                $window: $window,
                $uibModal: $modal,
                settingsService: settingsService,
                $filter: $filter,
                $timeout: $timeout,
                userStorage: userStorage,
                preloadedSkinsList: preloadedSkinsList
            },
            pristineConfig = {},
            openedItemsHistory = [],
            onlyChildes = $filter("onlyChildes"),
            orderBy = $filter("orderBy"),
            init,
            currentEditing = {
                menu: {}
            };

        $controller('MobileConfigurationController', dependency);

        $scope.skinsList = angular.copy(orderBy(preloadedSkinsList, "id"));
        $scope.search = {
            query: "",
            existingQuery: ""
        };

        $scope.skinsLimit = 0;
        $scope.openConfigId = $stateParams.configId;
        $scope.filters = {};

        <!-- skins functional start here -->


        $scope.getLimitedWord = function(word, size) {
            if(word.length <= size) {
                return word;
            } else {
                return word.substr(0, size) + '...';
            }
        }

        $scope.filterForRemove = function (skin) {
            if (!!$scope.search.existingQuery) {
                var regex = new RegExp("^" + $scope.search.existingQuery.toLowerCase());
                if (regex.test(skin.name.toLowerCase()) || regex.test(skin.id)) {
                    return true
                }
            } else {
                return true
            }
            return false
        };

        $scope.isAllowedToGetAllSkins = function () {
            return userStorage.getUserData() && userStorage.getUserData().permissions && userStorage.getUserData().permissions.indexOf('viewMobileSystemSettings') !== -1 && userStorage.getUserData().permissions.indexOf('allowSkinsListUse') !== -1;
        };


        function setCurrentVersion() {
            $scope.versionState = $scope.versionState || {};
            angular.forEach($scope.versions, function (version) {
                if (version.is_current == '1') {
                    return $scope.versionState.currentVersion = version;
                }
            });
        }

        function selectConfigWithChildes(config, isEnabled) {
            config.is_active_for_apply = isEnabled;
            if (config.child && config.child.length) {
                for (var i = 0, length = config.child.length; i < length; i++) {
                    config.child[i].is_active_for_apply = isEnabled;
                    if (config.child[i].child && config.child[i].child.length) {
                        selectConfigWithChildes(config.child[i], isEnabled)
                    }
                }
            }

        }

        $scope.duplicateConfig = function (config) {
            var modalInstance = $modal.open({
                templateUrl: "views/templates/modals/confirmDuplicateAction.html",
                controller: "ConfirmDeleteActionModalController"
            });

            modalInstance.result.then(function () {
                return mobileConfigsService.duplicateConfig({id: config.id}).then(
                    function (response) {
                        if (response.status == "ok") {
                            logger.logSuccess("global.configDuplicated");
                            setTimeout(function () {
                                $scope.$digest($scope.menuItems = duplicateConfigToMenu($scope.menuItems, response.mainConfig));
                            });
                            return;
                        }
                        errorHandler(response.message);
                    },
                    function (response) {
                        errorHandler(response.message);
                    }
                )
            })
        };

        function duplicateConfigToMenu(menu, config) {
            if (config.parent_id === '0') {
                menu.push(config);
                return menu;
            } else {
                return duplicateParentChild(menu, config);
            }
        }

        $scope.closePopup = function () {
            $scope.menuContnet = null
        };

        function duplicateParentChild(menu, config) {
            for (var i = 0; i < menu.length; i++) {
                if (menu[i].id === config.parent_id) {
                    menu[i].child.push(config);
                    menu[i].limitTo ++;
                    break;
                }
                if (menu[i].child && menu[i].child.length) {
                    duplicateConfigToMenu(menu[i].child, config)
                }
            }
            return menu;
        }

        function deleteFromMenu (menu, config) {
            for (var i = 0; i < menu.length; i++) {
                if (menu[i].id === config.id) {
                    menu.splice(i, 1);
                    menu.limitTo--;
                    break;
                }
                if (menu[i].child && menu[i].child.length) {
                    deleteFromMenu(menu[i].child, config)
                }
            }
            return menu
        }

        $scope.deleteConfig = function (config) {
            var modalInstance = $modal.open({
                templateUrl: "views/templates/modals/confirmDeleteAction.html",
                controller: "ConfirmDeleteActionModalController"
            });

            modalInstance.result.then(function () {
                if (userStorage.getUserData().permissions.indexOf('viewMobileSystemSettings') !== -1) {
                    return mobileConfigsService.deleteConfig({id: config.id}).then(
                        function (response) {
                            if (response.status == "ok") {
                                logger.logSuccess("global.configDeleted");
                                setTimeout(function () {
                                    $scope.$digest($scope.menuItems = deleteFromMenu($scope.menuItems, config))
                                });
                                return;
                            }
                            errorHandler(response.message);
                        },
                        function (response) {
                            errorHandler(response.message);
                        }
                    )
                }
                mobileConfigsService.deleteSkinConfig({config_id: config.config_id}).then(
                    function (response) {
                        if (response.status == "ok") {
                            logger.logSuccess("global.configDeleted");

                            // $scope.treeState.mutated = true;
                            // return $scope.resetTree();
                            setTimeout(function () {
                                $scope.$digest($scope.menuItems = deleteFromMenu($scope.menuItems, config))
                            });
                            return;
                        }
                        errorHandler(response.message);
                    },
                    function (response) {
                        errorHandler(response.message);
                    }
                )
            })
        };

        $scope.add = function (item) {
            item.switchEnabled = true
        };

        $scope.remove = function (item) {
            item.switchEnabled = false
        };

        $scope.applyConfigsToSkins = function () {
            mobileConfigsService.addConfigsSkins(fetchRequestData($scope.menuItems)).then(
                function (response) {
                    if (response.status == "ok") {
                        return logger.logSuccess("global.saved")
                    }
                    errorHandler(response.message);
                },
                function (response) {
                    errorHandler(response.message);
                }
            )
        };

        function fetchRequestData() {
            $scope.currentSelectedConfigs = [];
            fetchSelectedConfigs($scope.menuItems);

            return {
                addSkinConf: {
                    config_ids: $scope.currentSelectedConfigs,
                    skin_ids: fetchSelectedSkins([])
                }
            }
        }

        function fetchSelectedConfigs(arr) {
            for (var i = 0, length = arr.length; i < length; i++) {
                if (arr[i].is_active_for_apply) {
                    $scope.currentSelectedConfigs.push(arr[i].id);
                }
                if (arr[i].child && arr[i].child.length) {
                    fetchSelectedConfigs(arr[i].child)
                }
            }
        }

        function fetchSelectedSkins(arr) {
            for (var i = 0, length = $scope.skinsList.length; i < length; i++) {
                if ($scope.skinsList[i].switchEnabled) {
                    arr.push($scope.skinsList[i].id);
                }
            }
            return arr
        }

        <!-- skins functional end -->

        $scope.checkParents = function (parent, isSelected) {
            $scope.previous && $scope.previous.enableActive && ($scope.previous.enableActive = false);
            if (!isSelected) {
                return $scope.selectAllConfigs1(parent.menu || parent.$parent.menu || parent.$parent.$parent.menu || parent.$parent.$parent.$parent.menu, false)
            }
            if (parent.hasOwnProperty('menu')) {
                parent.menu.is_active_for_apply = isSelected;
            }
            if (parent.hasOwnProperty("$parent")) {
                if (!parent.hasOwnProperty("menuItems")) {
                    $scope.checkParents(parent.$parent, isSelected)
                }
            }
        };
        $scope.selectAllConfigs1 = function (config, isEnabled, parent) {
            if (isEnabled) {
                $scope.checkParents(parent, isEnabled)
            }
        };
        $scope.selectAllConfigs = function (config, isEnabled, parent) {
            if (isEnabled) {
                $scope.checkParents(parent, isEnabled)
            }
            selectConfigWithChildes(config, isEnabled);
        };
        /**
         * get user permissions aray
         * @returns {*}
         */
        $scope.getUserPermissions = function getUserPermissions(){
            return userStorage.getUserData().permissions;
        };
        $scope.openContent = function (menu) {
            if (!menu.limitTo) {
                menu.limitTo = menu.child ? menu.child.length : 1;
                $timeout(function () {
                    $scope.$broadcast("resetConfigDirective")
                })
            }

            if ($scope.treeOptions.showAllTreeElements) {
                return
            }

            if (userStorage.getUserData().permissions.indexOf('viewMobileSystemSettings') !== -1) {
                return
            }

            var index = openedItemsHistory.indexOf(menu);

            if (index < 0) {
                openedItemsHistory.length > 0 && closeSiblings(menu);
                openedItemsHistory.push(menu)
            } else {
                openedItemsHistory.splice(index, openedItemsHistory.length - index);
            }

            (init = function (menu) {
                $scope.allowOrder = menu.allowOrder;
                $scope.allowUpload = menu.allowUpload;
                $scope.configData = group(angular.copy(openedItemsHistory[openedItemsHistory.length - 1]));
                $scope.configData ? $scope.configData.seletedID = menu.id : null;
                pristineConfig = angular.copy($scope.configData);
                currentEditing.menu = menu;
            })(menu);

        };

        $scope.submitConfigForm = function () {
            var changes = deepCompare.getChanges(pristineConfig.child, $scope.configData.child, "configSkinId");
            var groups = Object.keys(changes);
            if (!groups.length) {
                return
            } else {
                var requestData = {};
                for (var i = 0; i < groups.length; i++) {
                    for (var prop in changes[groups[i]]) {
                        requestData[changes[groups[i]][prop]["configSkinId"]] = changes[groups[i]][prop]
                    }
                }
            }
            mobileConfigsService.updateConfigByConfigSkinId(requestData).then(
                function (response) {
                    if (response.status == "ok") {
                        saveDataForConfigs(requestData);
                        pristineConfig = angular.copy($scope.configData);
                        logger.logSuccess("global.updated");
                    } else {
                        errorHandler(response.message)
                    }
                },
                function (response) {
                    errorHandler(response.message)
                }
            )
        };

        function saveDataForConfigs (savedData) {
            for (var i = 0, length = currentEditing.menu.child.length; i < length; i++) {
                if (savedData.hasOwnProperty(currentEditing.menu.child[i].configSkinId)) {
                    currentEditing.menu.child[i].value = savedData[currentEditing.menu.child[i].configSkinId].value;
                }
            }
        }

        $scope.addConfig = function (menu) {
            $scope.menuContnet = menu;
            menu.adding = true;
            menu.editing = false;
            menu.addingItem = {
                parent_id: menu.id,
                value_type: 'text'
            }
        };

        $scope.editConfig = function (menu) {
            $scope.menuContnet = menu;
            menu.adding = true;
            menu.editing = true;
            menu.addingItem = {
                id: menu.id,
                key: menu.key,
                value: menu.value,
                value_type: menu.value_type,
                static: !!+menu.static,
                skin_dev: !!+menu.skin_dev,
                skin_admin: !!+menu.skin_admin,
                description: menu.description,
                visible_for_skin: !!+menu.visible_for_skin,
                default: !!+menu.default
            }
        };

        $scope.submitAddConfigForm = function (itemToCreate) {
            var requestData = angular.copy(itemToCreate);

            if (!!requestData.static) {
                delete requestData.skin_admin;
                delete requestData.skin_dev;
            } else {
                delete requestData.static
            }
            requestData.visible_for_skin = requestData.visible_for_skin? 1: 0;
            requestData.default = requestData.default?1:0;
            if (requestData.value_type == 'group') {
                delete requestData.value
            }

            mobileConfigsService.createConfig(requestData).then(
                function (response) {
                    if (response.status === "ok") {
                        logger.logSuccess("global.configCreated");
                        $scope.resetTree();
                        setChanges();
                        $scope.configGroup = {};
                        $scope.menuContnet = null
                    } else {
                        errorHandler(response.message)
                    }
                },
                function (response) {
                    errorHandler(response.message)
                }
            )
        };

        function isThereAnyChangesInEditMode (menu, item) {
            return  !function () {
                return  (menu.id == item.id) && (menu.key == item.key) && (menu.value_type == item.value_type) && (!!+menu.static == item.static) && (!!+menu.skin_admin == item.skin_admin) && (!!+menu.skin_dev == item.skin_dev) && (menu.description == item.description) && (menu.value == item.value) && (!!+menu.visible_for_skin == item.visible_for_skin) && (!!+menu.default == item.default)
            } ()
        }

        $scope.submitEditConfigForm = function (menu, item) {
            if (!isThereAnyChangesInEditMode(menu, item)) {
                return logger.logError("global.no_changes")
            }

            var requestData = angular.copy(item);
            requestData.visible_for_skin = requestData.visible_for_skin? 1: 0;
            requestData.default = requestData.default?1:0;
            if (!!requestData.static) {
                delete requestData.skin_admin;
                delete requestData.skin_dev;
            }

            if (requestData.value_type == 'group') {
                delete requestData.value
            }

            mobileConfigsService.editConfig(requestData).then(
                function (response) {
                    if (response.status === "ok") {
                        setChanges();
                        logger.logSuccess("global.configUpdated");
                        $scope.menuContnet = null
                    } else {
                        errorHandler(response.message)
                    }
                },
                function (response) {
                    errorHandler(response.message)
                }
            )
        };

        $scope.applyConfigs = function () {
            var modalInstance = $modal.open({
                templateUrl: "views/templates/modals/confirmApplyConfigAction.html",
                controller: "ConfirmApplyConfigModalController"
            });

            modalInstance.result.then(
                function (applyMessage) {
                    mobileConfigsService.applyConfigs({message: applyMessage}).then(
                        function (response) {
                            if (response.status == "ok") {
                                $scope.resetConfigs(userStorage.getUserData().skin_id, true, true, function () {
                                    logger.logSuccess("global.configApplied")
                                });
                            } else {
                                errorHandler(response.message)
                            }
                        },
                        function (response) {
                            errorHandler(response.message)
                        }
                    )
                }
            );
        };

        $scope.resetTree = function (force) {
            $timeout(function () {
                $scope.resetConfigs();
            }, force === true ? 0 : 300);
        };

        $scope.resetConfigs = function (skinId, force, updateVersions, callBack) {
            setChanges(function () {
                openedItemsHistory = [];
                currentEditing = {
                    menu: {}
                };
                $scope.treeState.mutated = false;
                searchQuery = "";
                $scope.suggestions = {
                    matches: [],
                    isResultDone: false
                };

                $scope.search = {
                    query: ""
                };

                $timeout(function () {
                    $scope.$broadcast("resetConfigDirective")
                });


                pristineConfig = {};

                $scope.configData = undefined;

                if (updateVersions) {
                    mobileConfigsService.getVersionsBySkinId(skinId).then(
                        function (response) {
                            if (response.status == "ok") {
                                $scope.versions = angular.copy(response.versions) || {};
                                setCurrentVersion();
                                callBack && callBack();
                            } else {
                                errorHandler(response.message)
                            }
                        },
                        function (response) {
                            errorHandler(response.message)
                        }
                    );
                }

            }, skinId, force);
        };

        $scope.revertConfigVersion = function () {
            if (!$scope.versionState.currentVersion){
                return;
            }
            var modalInstance = $modal.open({
                templateUrl: "views/templates/modals/confirmRevertConfigAction.html",
                controller: "ConfirmRevertConfigModalController",
                resolve: {
                    preloadedData: function () {
                        return angular.copy($scope.versionState.currentVersion)
                    }
                }
            });

            modalInstance.result.then(
                function (configVersion) {
                    mobileConfigsService.revertConfigVersion(configVersion.id, configVersion.message).then(
                        function (response) {
                            if (response.status == "ok") {
                                $scope.treeState.mutated = true;
                                $scope.resetConfigs(userStorage.getUserData().skin_id, true, true, function () {
                                    logger.logSuccess("global.successfullyDeleted")
                                });
                            } else {
                                errorHandler(response.message);
                            }
                        },
                        function (response) {
                            errorHandler(response.message);
                        }
                    )
                }
            );
        };

        $scope.selectParent = function (config, emptyQuery) {
            $scope.search.query = !emptyQuery ?  config.key : '';
            $scope.treeState.mutated = true;
            $scope.suggestions.matches = [];
            $scope.suggestions.isResultDone = true;
            mobileConfigsService.searchConfig({parent_id: config.parent_id, key: config.key}).then(
                function (response) {
                    if (response.status == "ok") {
                        preloadedConfigs = angular.copy($scope.menuItems);
                        $scope.menuItems = angular.copy(response.configs);
                    } else {
                        errorHandler(response.error)
                    }
                },
                function (response) {
                    errorHandler(response.error)
                }
            )
        };

        function getRequest() {
            var requestData = {};
            switch($scope.filters.configType){
                case '1':
                    requestData.default = 1;
                    break;
                case '2':
                    requestData.visible_for_skin = 1;
                    break;
            }
            return requestData;
        }

        $scope.loadConfigs = function loadConfigs() {
            mobileConfigsService.getConfigsMenu(getRequest()).then(
                function (response) {
                    preloadedConfigs = angular.copy(response.configs) || {};
                    $scope.menuItems = angular.copy(preloadedConfigs);

                },
                function (error) {
                    errorHandler(error.message);
                    return null
                }
            );
        };

        $scope.openPreviewWindow = function (parentId) {
            var configTypeParam = "";
            switch($scope.filters.configType) {
                case "1":
                    configTypeParam = "&default=1";
                    break;
                case "2":
                    configTypeParam = "&visible_for_skin=1";
                    break;
            }
            $window.open("/config/mobileConfPreview?CKEditor=sd" + (parentId? ('&parent_id=' + parentId): '') + configTypeParam , "Mobile Config", "width=1000,height=800");
        };

        function closeSiblings(menu) {
            var i = 0, orderLevel = menu.orderLevel;
            while (openedItemsHistory[i]) {
                if (openedItemsHistory[i].orderLevel == orderLevel) {
                    return openedItemsHistory.splice(i, openedItemsHistory.length - i);
                }
                i++;
            }
        }

        function group(childes) {
            var childesToShow = (!!childes && !!childes.child) ? onlyChildes(childes.child) : [],
                returnObj = {},
                i = 0;

            while (childesToShow[i]) {
                returnObj[childesToShow[i].mark || "null"] = returnObj[childesToShow[i].mark || "null"] || [];
                returnObj[childesToShow[i].mark || "null"].push(childesToShow[i]);
                i++;
            }
            if (!!childes) {
                return {child: returnObj, static: childes && childes.static}
            }
        }

        function setChanges(cb) {
            if (!$scope.treeState.mutated && cb) {
                return cb();
            }
            mobileConfigsService.getConfigsMenu().then(
                function (response) {
                    $scope.menuItems = angular.copy(response.configs);
                    cb && cb()
                },
                function (error) {
                    errorHandler(error.message);
                    return null
                }
            )
        }

        //@TODO check
        if ($scope.openConfigId) {
            var openConfig = $filter("configSkinByConfigId")($scope.menuItems, $scope.openConfigId);

            openConfig = (openConfig && !openConfig.child && openConfig.parent) ? openConfig.parent : openConfig;;
            if (openConfig) {
                // $scope.selectParent(openConfig, true);
                $scope.openContent(openConfig);
            }
        }


        function keyDownListener(event) {
            var  keyCode = event.keyCode;
            if (keyCode === 38){
                $scope.arrowUpListener();
            } else if(keyCode === 40) {
                $scope.arrowDownListener();
            } else if (keyCode === 13){
                $scope.enterListener();
            }
        }

        document.body.addEventListener('keydown', keyDownListener);
        $scope.$on("$destroy", function (event) {
            document.body.removeEventListener('keydown', keyDownListener);
        });

    }
]);
